/* eslint-disable array-callback-return */
import { useState, useEffect } from "react";
import { EDBService } from "$services";
import { DispositionType } from "$types";
import useAuth from "./useAuth";
import { emailRegexp } from "$utils/utils";

const useEDBFormulaire = (edb?: any) => {
  const { token } = useAuth();
  // hook for popin Give instructions
  const [showData, setShowData] = useState({
    dispositiontype: true,
    contact: false,
    dateDisposition: false,
    nomEntrepot: false,
    adressDisposition: false,
    note: false,
  });
  const [notes, setNotes] = useState("");
  const [entrepotName, setEntrepotName] = useState("");
  const [preparationType, setPreparationType] = useState<string>(
    "Préparation pour mise à disposition"
  );
  const [dispositionType, setDispositionType] = useState<string>(
    DispositionType.ON_DOCKYARD
  );

  const [contactRecovery, setContactRecovery] = useState<any>({
    name: {
      value: "",
      error: "",
      isRequired: false,
      isDisabled: false,
    },
    surname: {
      value: "",
      error: "",
      isRequired: false,
      isDisabled: false,
    },
    email: {
      value: "",
      error: "",
      isRequired: false,
      isDisabled: false,
    },
    phone: {
      value: "",
      error: "",
      isRequired: false,
      isDisabled: false,
    },
  });

  const [disposition, setDisposition] = useState<any>({
    adress: {
      value: "",
      error: "",
      isRequired: true,
      isDisabled: false,
    },
    complementAdress: {
      value: "",
      error: "",
      isRequired: false,
      isDisabled: false,
    },
    postalCode: {
      value: "",
      error: "",
      isRequired: true,
      isDisabled: false,
    },
    city: {
      value: "",
      error: "",
      isRequired: true,
      isDisabled: false,
    },
    country: {
      value: "France",
      error: "",
      isRequired: true,
      isDisabled: false,
    },
    dateDisposition: {
      value: "",
      error: "",
      isRequired: true,
      isDisabled: false,
    },
    dispositionDateIsExact: {
      value: true,
      error: "",
      isRequired: true,
      isDisabled: false,
    },
  });
  const [errorForm, setErrorForm] = useState("");
  // end hook for popin Give instructions

  const handleChangeSTep3Form = (
    key: string,
    value: string | boolean,
    data: any,
    setData: any,
    isRequired = false,
    _regex?: string,
    errorMessage?: string
  ) => {
    const newData = { ...data };
    const rgx = new RegExp(_regex || "");
    if (!value && isRequired) {
      newData[key].value = value;
      newData[key].error = "Veuillez remplir ce champ";
    } else {
      // eslint-disable-next-line no-lonely-if
      if (rgx.test(value as string) || (!isRequired && value === "")) {
        newData[key].value = value;
        newData[key].error = "";
      } else {
        newData[key].error = errorMessage;
      }
      // newData[key] = value;
    }
    setData(newData);
  };

  const checkEDB = () => {
    handleChangeSTep3Form(
      "adress",
      disposition.adress.value,
      disposition,
      setDisposition,
      disposition.adress.isRequired
    );
    handleChangeSTep3Form(
      "complementAdress",
      disposition.complementAdress.value,
      disposition,
      setDisposition,
      disposition.complementAdress.isRequired
    );
    handleChangeSTep3Form(
      "postalCode",
      disposition.postalCode.value,
      disposition,
      setDisposition,
      disposition.postalCode.isRequired
    );
    handleChangeSTep3Form(
      "city",
      disposition.city.value,
      disposition,
      setDisposition,
      disposition.city.isRequired
    );
    handleChangeSTep3Form(
      "country",
      disposition.country.value,
      disposition,
      setDisposition,
      disposition.country.isRequired
    );
    handleChangeSTep3Form(
      "dateDisposition",
      disposition.dateDisposition.value,
      disposition,
      setDisposition,
      disposition.dateDisposition.isRequired
    );
    handleChangeSTep3Form(
      "dispositionDateIsExact",
      disposition.dispositionDateIsExact.value,
      disposition,
      setDisposition,
      disposition.dateDisposition.isRequired
    );

    const keys = Object.keys(disposition);
    let resp = true;
    keys.map((k: string) => {
      if (disposition[k].error !== "") {
        resp = false;
      }
    });

    handleChangeSTep3Form(
      "email",
      contactRecovery.email.value,
      contactRecovery,
      setContactRecovery,
      false,
      emailRegexp.toString(),
      "Veuillez saisir une adresse e-mail valide"
    );
    handleChangeSTep3Form(
      "phone",
      contactRecovery.phone.value,
      contactRecovery,
      setContactRecovery,
      false,
      "([0-9]){10}$",
      "Veuillez saisir un numéro de téléphone valide"
    );

    const keysContact = Object.keys(contactRecovery);
    keysContact.map((k: string) => {
      if (contactRecovery[k].error !== "") {
        resp = false;
      }
    });

    return resp;
  };

  const updateEdb = async (updateEdbList: any, indexEdb: number) => {
    const isValid = checkEDB();
    if (isValid) {
      const data = {
        preparationType,
        dispositionType,
        dispositionDate: disposition.dateDisposition.value,
        dispositionDateIsExact: disposition.dispositionDateIsExact.value,
        dispositionAdress: disposition.adress.value,
        dispositionAdress2: disposition.complementAdress.value,
        dispositionPostalCode: disposition.postalCode.value,
        dispositionCity: disposition.city.value,
        dispositionCountry: disposition.country.value,
        notes,
        entrepotName,
        lastnameContactRecovery: contactRecovery.name.value,
        firstnameContactRecovery: contactRecovery.surname.value,
        emailContactRecovery: contactRecovery.email.value,
        phoneContactRecovery: contactRecovery.phone.value,
      };
      EDBService.UpdateEDB(token, { ...data }, edb._id)
        .then(async () => {
          setErrorForm("");
          updateEdbList(indexEdb, data);
        })
        .catch(() => {
          setErrorForm(
            "Une erreur est intervenue lors de la mise à jour de l'EDB"
          );
        });
      return true;
    }
    return false;
  };

  useEffect(() => {
    switch (dispositionType) {
      case DispositionType.NEAREST_WAREHOUSE:
        setShowData((oldShowData) => ({
          ...oldShowData,
          contact: true,
          dateDisposition: true,
          nomEntrepot: false,
          adressDisposition: false,
          note: true,
        }));
        setContactRecovery({
          name: {
            value: "",
            error: "",
            isRequired: false,
            isDisabled: false,
          },
          surname: {
            value: "",
            error: "",
            isRequired: false,
            isDisabled: false,
          },
          email: {
            value: "",
            error: "",
            isRequired: false,
            isDisabled: false,
          },
          phone: {
            value: "",
            error: "",
            isRequired: false,
            isDisabled: false,
          },
        });
        setDisposition((oldDisposition) => ({
          ...oldDisposition,
          adress: {
            value: "",
            error: "",
            isRequired: false,
            isDisabled: true,
          },
          complementAdress: {
            value: "",
            error: "",
            isRequired: false,
            isDisabled: true,
          },
          postalCode: {
            value: "",
            error: "",
            isRequired: false,
            isDisabled: true,
          },
          city: {
            value: "",
            error: "",
            isRequired: false,
            isDisabled: true,
          },
          country: {
            value: "France",
            error: "",
            isRequired: false,
            isDisabled: true,
          },
          dateDisposition: {
            value: "",
            error: "",
            isRequired: true,
            isDisabled: false,
          },
          dispositionDateIsExact: {
            value: true,
            error: "",
            isRequired: true,
            isDisabled: false,
          },
        }));
        break;
      case DispositionType.SUBCONTRACTED_WAREHOUSE:
        setShowData((oldShowData) => ({
          ...oldShowData,
          contact: true,
          dateDisposition: true,
          nomEntrepot: true,
          adressDisposition: true,
          note: true,
        }));
        setContactRecovery({
          name: {
            value: "",
            error: "",
            isRequired: false,
            isDisabled: false,
          },
          surname: {
            value: "",
            error: "",
            isRequired: false,
            isDisabled: false,
          },
          email: {
            value: "",
            error: "",
            isRequired: false,
            isDisabled: false,
          },
          phone: {
            value: "",
            error: "",
            isRequired: false,
            isDisabled: false,
          },
        });
        setDisposition((oldDisposition) => ({
          ...oldDisposition,
          adress: {
            ...oldDisposition.adress,
            value: "",
            isRequired: true,
            isDisabled: false,
          },
          complementAdress: {
            ...oldDisposition.complementAdress,
            value: "",
            isRequired: false,
            isDisabled: false,
          },
          postalCode: {
            ...oldDisposition.postalCode,
            value: "",
            isRequired: true,
            isDisabled: false,
          },
          city: {
            ...oldDisposition.city,
            value: "",
            isRequired: true,
            isDisabled: false,
          },
          country: {
            ...oldDisposition.country,
            value: "France",
            isRequired: true,
            isDisabled: false,
          },
          dateDisposition: {
            value: "",
            error: "",
            isRequired: true,
            isDisabled: false,
          },
          dispositionDateIsExact: {
            value: true,
            error: "",
            isRequired: true,
            isDisabled: false,
          },
        }));
        break;
      default:
        setShowData((oldShowData) => ({
          ...oldShowData,
          contact: true,
          dateDisposition: true,
          nomEntrepot: false,
          adressDisposition: true,
          note: true,
        }));
        setContactRecovery({
          name: {
            value: edb?.dockyard?.firstnameContact || "",
            error: "",
            isRequired: false,
            isDisabled: false,
          },
          surname: {
            value: edb?.dockyard?.lastnameContact || "",
            error: "",
            isRequired: false,
            isDisabled: false,
          },
          email: {
            value: edb?.dockyard?.emailContact || "",
            error: "",
            isRequired: false,
            isDisabled: false,
          },
          phone: {
            value: edb?.dockyard?.phoneContact || "",
            error: "",
            isRequired: false,
            isDisabled: false,
          },
        });
        setDisposition({
          adress: {
            value: edb?.dockyard?.address || "",
            error: "",
            isRequired: true,
            isDisabled: true,
          },
          complementAdress: {
            value: edb?.dockyard?.address2 || "",
            error: "",
            isRequired: false,
            isDisabled: true,
          },
          postalCode: {
            value: edb?.dockyard?.postalCode || "",
            error: "",
            isRequired: true,
            isDisabled: true,
          },
          city: {
            value: edb?.dockyard?.city || "",
            error: "",
            isRequired: true,
            isDisabled: true,
          },
          country: {
            value: edb?.dockyard?.country || "France",
            error: "",
            isRequired: true,
            isDisabled: true,
          },
          dateDisposition: {
            value: "",
            error: "",
            isRequired: true,
            isDisabled: true,
          },
          dispositionDateIsExact: {
            value: true,
            error: "",
            isRequired: true,
            isDisabled: false,
          },
        });
        break;
    }
  }, [dispositionType, edb]);

  return {
    handleChangeSTep3Form,
    disposition,
    setDisposition,
    showData,
    setShowData,
    dispositionType,
    contactRecovery,
    notes,
    setPreparationType,
    setDispositionType,
    setContactRecovery,
    setNotes,
    updateEdb,
    setEntrepotName,
    errorForm,
  };
};

export default useEDBFormulaire;
